import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";

import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { CustomersRoutingModule } from "./customers-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { PropertiesModule } from "src/app/shared/modules/properties/properties.module";
import { DateTimeModule } from "src/app/shared/modules/date-time/date-time.module";

import { CustomerListComponent } from "./customer-list/customer-list.component";
import { CustomerDetailComponent } from "./customer-detail/customer-detail.component";
import { CustomerEmployeesListComponent } from "./customer-employees-list/customer-employees-list.component";
import { CustomerContractsListComponent } from './customer-contracts-list/customer-contracts-list.component';
import { CustomerCardsListComponent } from './customer-cards-list/customer-cards-list.component';
import { CustomerVehiclesListComponent } from './customer-vehicles-list/customer-vehicles-list.component';
import { CustomerMovementsListComponent } from './customer-movements-list/customer-movements-list.component';
import { CurrentAccountsModule } from "../current-accounts-Management/current-accounts.module";

@NgModule({
  imports: [
    CommonModule,
    CustomersRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    DateTimeModule,
    FlexLayoutModule,
    CategoriesModule,
    PropertiesModule,
    CurrentAccountsModule
  ],
  declarations: [
    CustomerListComponent,
    CustomerDetailComponent,
    CustomerEmployeesListComponent,
    CustomerContractsListComponent,
    CustomerCardsListComponent,
    CustomerVehiclesListComponent,
    CustomerMovementsListComponent,
  ],
})
export class CustomersModule {}
